import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { X } from 'lucide-react';

const SubItemSelector = ({ selectedSubItems, onToggle }) => {
  const { subItems } = useSelector((state) => state.subItem);
  const [search, setSearch] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  const filteredItems = subItems.filter(sub =>
    sub.name.toLowerCase().includes(search.toLowerCase())
  );

  const selectedSubItemObjs = subItems.filter(sub => selectedSubItems.includes(sub.id));

  return (
    <div className="col-span-2 mt-6">
      <h3 className="text-lg font-semibold mb-2">Sub Items</h3>

      {/* Selected Items Display */}
      <div className="flex flex-wrap gap-2 mb-2">
        {selectedSubItemObjs.map((item) => (
          <div key={item.id} className="flex items-center bg-gray-200 rounded px-2 py-1 text-sm">
            {item.name}
            <button
              type="button"
              onClick={() => onToggle(item.id)}
              className="ml-1 text-gray-600 hover:text-red-500"
            >
              <X size={14} />
            </button>
          </div>
        ))}
      </div>

      {/* Input Box for Search */}
      <div className="relative">
        <input
          type="text"
          className="w-full px-4 py-2 border rounded"
          placeholder="Search and select sub items..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onFocus={() => setIsOpen(true)}
          onBlur={() => setTimeout(() => setIsOpen(false), 150)} // allow click before closing
        />

        {isOpen && (
          <ul className="absolute z-10 mt-1 max-h-48 w-full overflow-auto bg-white border rounded shadow">
            {filteredItems.map((item) => (
              <li
                key={item.id}
                onClick={() => {
                  onToggle(item.id);
                  setSearch('');
                }}
                className="cursor-pointer px-4 py-2 hover:bg-gray-100"
              >
                {item.name}
              </li>
            ))}
            {filteredItems.length === 0 && (
              <li className="px-4 py-2 text-gray-400">No items found</li>
            )}
          </ul>
        )}
      </div>
    </div>
  );
};

export default SubItemSelector;
